<template>
	<ul class="deal-list">
		<li class="deal-item">
			<span class="deal-item__title">类型 </span>
			<span class="deal-item__content">{{state.type}}</span>
		</li>
		<li class="deal-item">
			<span class="deal-item__title">节点</span>
			<span class="deal-item__content">{{state.nodes}} </span>
		</li>
		<li class="deal-item">
			<span class="deal-item__title">独特的运营商</span>
			<span class="deal-item__content">{{state.uniqueOperators}}</span>
		</li>
		<li class="deal-item">
			<span class="deal-item__title">独特的供应商</span>
			<span class="deal-item__content">{{state.uniqueProviders}}</span>
		</li>
		<li class="deal-item">
			<span class="deal-item__title">总罐</span>
			<span class="deal-item__content">{{state.totalCanisters}}</span>
		</li>
	</ul>
</template>

<script>
import { serchSubnets } from '../../../serve/request'
export default {
    props: ['state'],
	data() {
		return {
			state: {
				type: '已验证的应用程序',
				nodes: 0,
				uniqueOperators: 0,
				uniqueProviders: 0,
				totalCanisters: 0
			},
			price: 1.0
		}
	},
	methods: {

	},
	created() {
		// this.getPrice()

	}
}
</script>

<style lang="scss" scoped>
</style>
